(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forge-header"]) return;
  try {
    
(function () {
  function mountMarquees() {
    document.querySelectorAll('[data-forge-marquee]').forEach(function (bar) {
      if (bar.dataset.ready === 'true') return;
      var button = bar.querySelector('[data-marquee-pause]');
      if (!button) return;
      button.addEventListener('click', function () {
        var paused = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(paused));
        bar.dataset.paused = String(paused);
      });
      button.hidden = false;
      bar.dataset.ready = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountMarquees);
  else mountMarquees();
  document.addEventListener('shopify:section:load', mountMarquees);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forge-live-window"]) return;
  try {
    
(function () {
  if (window.__forgeLiveInstalled) return;
  window.__forgeLiveInstalled = true;
  var active;
  function mount() {
    if (active) active.stop();
    var root = document.querySelector('[data-forge-live-root]');
    if (!root) return;
    var sectionId = root.dataset.sectionId;
    var running = true, pending = false, pollTimer, expiryTimer, abortTimer, controller;
    var lastMarkup = '', openChoice = null;
    function metadata(panel) {
      if (!panel) return null;
      var platform = panel.dataset.platform;
      if (platform !== 'tiktok' && platform !== 'whatnot') return null;
      var link = panel.querySelector('[data-live-destination]'), url;
      try { url = new URL(link.getAttribute('href')); } catch (error) { return null; }
      var domain = platform === 'whatnot' ? 'whatnot.com' : 'tiktok.com';
      var host = url.hostname.toLowerCase(), end = Date.parse(panel.dataset.end);
      if (url.protocol !== 'https:' || url.username || url.password ||
          !(host === domain || host.endsWith('.' + domain)) ||
          !Number.isFinite(end) || Date.now() >= end) return null;
      return {end: end};
    }
    function remember() {
      var details = root.querySelector('details');
      if (details) openChoice = details.open;
    }
    function clear() {
      remember();
      root.replaceChildren();
      lastMarkup = '';
    }
    function expire() {
      var panel = root.querySelector('[data-forge-live]');
      if (!panel) return;
      if (!metadata(panel)) { clear(); return; }
      panel.hidden = false;
    }
    function bind(panel) {
      if (!metadata(panel)) { clear(); return; }
      var details = panel.querySelector('details');
      if (details) {
        if (openChoice !== null) details.open = openChoice;
        else if (window.matchMedia && window.matchMedia('(max-width: 600px)').matches) details.open = false;
        details.addEventListener('toggle', function () { if (details.isConnected) openChoice = details.open; });
      }
      var button = panel.querySelector('[data-load-video]');
      if (button) button.addEventListener('click', function () {
        if (!metadata(panel)) { clear(); return; }
        var box = button.closest('[data-video]'), id = box.dataset.video;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1';
        frame.title = button.textContent.trim();
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        box.replaceChildren(frame);
      });
      panel.hidden = false;
    }
    function apply(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = Array.from(parsed.querySelectorAll('[data-forge-live-root]')).find(function (node) {
        return node.dataset.sectionId === sectionId;
      });
      if (!fresh) return;
      var panel = fresh.querySelector('[data-forge-live]');
      if (!panel || !metadata(panel)) { clear(); return; }
      var markup = panel.outerHTML;
      if (markup === lastMarkup) { expire(); return; }
      remember();
      panel.querySelectorAll('script, style, link').forEach(function (node) { node.remove(); });
      var imported = document.importNode(panel, true);
      root.replaceChildren(imported);
      lastMarkup = markup;
      bind(imported);
    }
    var canPoll = Boolean(root.dataset.forgeLivePoll === 'true' && window.Shopify && !window.Shopify.designMode && sectionId &&
      window.location.protocol === 'https:' && !/^(localhost|127\.0\.0\.1|\[::1\])$/i.test(window.location.hostname) &&
      window.fetch && window.AbortController);
    function schedule() {
      clearTimeout(pollTimer);
      if (running && canPoll) pollTimer = setTimeout(refresh, 60000);
    }
    async function refresh() {
      if (!running || pending) return;
      if (document.hidden) { schedule(); return; }
      pending = true;
      controller = new AbortController();
      var request = controller, timedOut = false;
      abortTimer = setTimeout(function () { timedOut = true; request.abort(); }, 10000);
      try {
        var url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', sectionId);
        var response = await window.fetch(url.toString(), {
          credentials: 'same-origin', cache: 'no-store', signal: request.signal,
          headers: {Accept: 'application/json'}
        });
        if (!response.ok) throw new Error('Section unavailable');
        var sections = await response.json();
        if (running && !timedOut && !request.signal.aborted && typeof sections[sectionId] === 'string') apply(sections[sectionId]);
      } catch (error) {
        if (running) expire();
      } finally {
        clearTimeout(abortTimer);
        controller = null;
        pending = false;
        schedule();
      }
    }
    function visibility() {
      if (document.hidden) {
        clearTimeout(pollTimer);
        if (controller) controller.abort();
      } else {
        expire();
        if (canPoll) refresh();
      }
    }
    var initial = root.querySelector('[data-forge-live]');
    if (initial) { lastMarkup = initial.outerHTML; bind(initial); }
    expiryTimer = setInterval(expire, 15000);
    document.addEventListener('visibilitychange', visibility);
    active = {stop: function () {
      running = false;
      clearTimeout(pollTimer);
      clearTimeout(abortTimer);
      clearInterval(expiryTimer);
      if (controller) controller.abort();
      document.removeEventListener('visibilitychange', visibility);
    }};
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-forge-live-root]') && active) active.stop();
  });
  window.addEventListener('pagehide', function () { if (active) active.stop(); });
  window.addEventListener('pageshow', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
